import { categories } from '@/mocks/content';

interface CategorySectionProps {
  activeCategory: string;
  onSelect: (id: string) => void;
}

export default function CategorySection({ activeCategory, onSelect }: CategorySectionProps) {
  return (
    <section id="categories" className="scroll-mt-nav py-12 md:py-16">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 flex items-center justify-center gap-2">
              <i className="ri-apps-2-line text-accent-500"></i>
              分类导航
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              点选任意题材，下方的精选合集会自动筛选出对应内容，帮助你从大方向逐步缩小范围。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {categories.map((c) => {
              const active = activeCategory === c.id;
              return (
                <button
                  key={c.id}
                  type="button"
                  onClick={() => onSelect(active ? '' : c.id)}
                  className={`flex items-center gap-3 p-4 rounded-lg border text-left cursor-pointer transition-colors ${
                    active
                      ? 'bg-primary-500 border-primary-500 text-background-50'
                      : 'bg-background-50 border-background-200 text-foreground-800 hover:border-accent-300'
                  }`}
                >
                  <span
                    className={`w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-md ${
                      active ? 'bg-background-50/20 text-background-50' : 'bg-accent-100 text-accent-700'
                    }`}
                  >
                    <i className={`${c.icon} text-xl`}></i>
                  </span>
                  <span className="min-w-0">
                    <span className="block text-sm font-bold whitespace-nowrap">{c.name}</span>
                    <span className={`block text-xs ${active ? 'text-background-50/80' : 'text-foreground-500'}`}>
                      {c.count} 个合集
                    </span>
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}